import React from 'react';

interface EmailIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const EmailIcon: React.FC<EmailIconProps> = ({ size = 25, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        d="M22.1 0.5H2.9C1.58 0.5 0.512 1.85 0.512 3.5L0.5 21.5C0.5 23.15 1.58 24.5 2.9 24.5H22.1C23.42 24.5 24.5 23.15 24.5 21.5V3.5C24.5 1.85 23.42 0.5 22.1 0.5ZM22.1 6.5L12.5 14L2.9 6.5V3.5L12.5 11L22.1 3.5V6.5Z"
        fill="#27788C"
        stroke="black"
      />
    </svg>
  );
};

export default EmailIcon;
